import { createSlice } from '@reduxjs/toolkit';
import cuid from 'cuid';

export const { actions, reducer } = createSlice({
    name: 'cuid',
    initialState: cuid(),
    reducers: {}
});